import {
  cn,
  Table,
  TableBody,
  TableCell,
  TableDensity,
  TableHeader,
  TableRow,
} from '@crossnokaye/ux-common';

import { CompressorEnergyAIStageHeader } from './compressor-energy-ai-stage-header';
import { ENERGY_AI_FORECAST_UNAVAILABLE_DETAIL } from '../compressor-energy-ai.constants';

interface CompressorEnergyAIStageTableProps {
  children: React.ReactNode;
  isEnergyAIActive: boolean;
  showForecastUnavailable: boolean;
}

/**
 * Chrome shared by the loading and loaded states: header, body rows, and the
 * trailing ACTIVE/INACTIVE status row.
 */
export const CompressorEnergyAIStageTable = ({
  children,
  isEnergyAIActive,
  showForecastUnavailable,
}: CompressorEnergyAIStageTableProps) => {
  return (
    <div
      className="overflow-hidden"
      data-component="CompressorEnergyAIStageTable"
      data-testid="compressor-energy-ai-stage-table"
    >
      <Table className="w-auto border-separate" density={TableDensity.COMFORTABLE}>
        <TableHeader>
          <TableRow>
            <CompressorEnergyAIStageHeader isEnergyAIActive={isEnergyAIActive} />
          </TableRow>
        </TableHeader>
        <TableBody>
          {children}
          <TableRow data-component="CompressorEnergyAIStageStatusRow">
            <TableCell className="h-[inherit] border-b-1 border-l-1 border-black p-0">
              <div className="flex h-full flex-col items-center justify-center gap-0.5 bg-ckds-neutral-900 px-1 py-1 text-xs font-bold">
                <span
                  className={cn(
                    'flex w-full items-center justify-center rounded-sm px-1 py-0.5 text-xs leading-none',
                    isEnergyAIActive
                      ? 'bg-ckds-brand-500 text-ckds-neutral-950'
                      : 'text-ckds-text-fg-tier3'
                  )}
                >
                  {isEnergyAIActive ? 'ACTIVE' : 'INACTIVE'}
                </span>
                {showForecastUnavailable ? (
                  <span className="text-center text-xs font-normal leading-tight text-ckds-text-fg-tier3">
                    {ENERGY_AI_FORECAST_UNAVAILABLE_DETAIL}
                  </span>
                ) : null}
              </div>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
};
